export default __webpack_public_path__ + "static/media/icon-zoom-out.3dd73a6e.svg";